import Api from "./Api.service"
export default class CosaService {
    static SubirArchivos(formData) {
        return Api.post("archivo/subir", formData);
    }
    static ActualizarComisiones(semestre) {
        return Api.get(`serviceApi/comisiones/${semestre}`);
    }
    
}